import { createContext, useState, useContext, ReactNode } from "react";
import { Collection } from "../types/form.types";

interface ServiceDataContextType {
  documentTypes: Collection[];
  hobbies: Collection[];
  departments: Collection[];
  cities: Collection[];

  setDocumentTypes: (collection: Collection[]) => void;
  setHobbies: (collection: Collection[]) => void;
  setDepartments: (collection: Collection[]) => void;
  setCities: (collection: Collection[]) => void;
}

const ServiceDataContext = createContext<ServiceDataContextType | null>(null);

export const ServiceDataProvider = ({ children }: { children: ReactNode }) => {
  const [documentTypes, setDocumentTypes] = useState<Collection[]>([]);
  const [hobbies, setHobbies] = useState<Collection[]>([]);
  const [departments, setDepartments] = useState<Collection[]>([]);
  const [cities, setCities] = useState<Collection[]>([]);

  return (
    <ServiceDataContext.Provider
      value={{
        documentTypes,
        hobbies,
        departments,
        cities,
        setDocumentTypes,
        setHobbies,
        setDepartments,
        setCities,
      }}
    >
      {children}
    </ServiceDataContext.Provider>
  );
};

export const useServiceData = () => {
  const context = useContext(ServiceDataContext);
  if (!context) {
    throw new Error("useServiceData debe usarse dentro de ServiceDataProvider");
  }
  return context;
};
